import React from 'react'
import Text from './Elements/Text'
import logo from '../images/RH-Vectorised-Logo-white.svg'
import { observer } from 'mobx-react-lite';
import { useStore } from '../Stores/store';

const Footer = observer(() => {
    const { generalStore } = useStore();
    const { showFooterAndNav } = generalStore;

    if (!showFooterAndNav) return <></>;
    return (
        <div className="bg-blue-900 opacity-90 text-white text-center py-5 flex flex-col">
            <img src={logo} alt="Logo" className="w-20 mx-auto py-4" />
            <Text className="text-sm">This site was created by Ryan (shameless plug)</Text>
        </div>
    )
});

export default Footer